import PromotionalBannerWrapper from './PromotionalBannerWrapper';

export default PromotionalBannerWrapper;
